import styled from 'styled-components';

import { device } from 'styles/device';

interface ListItemProps {
  isActive?: boolean;
}

export const Container = styled.div`
  width: 100%;
  margin: 17px auto 0 auto;

  @media ${device.sm} {
    max-width: 540px;
  }

  @media ${device.md} {
    max-width: 720px;
  }

  @media ${device.lg} {
    max-width: 960px;
  }

  @media ${device.xl} {
    max-width: 1230px;
  }
`;

export const ListWrapper = styled.ul`
  list-style: none;
  display: flex;
  align-items: center;
  margin-bottom: 0;

  svg {
    margin: 0 10px;
    color: #b8c0cc;
  }
`;

export const ListItem = styled.li<ListItemProps>`
  font-weight: 500;
  font-size: 12px;
  line-height: 10px;
  letter-spacing: 0.5px;
  cursor: pointer;

  color: ${({ isActive }) => (isActive ? '#4A90E2' : '#7A8799')};

  &:hover {
    text-decoration: underline;
  }
`;
